import { useMemo } from 'react'

import { orderBy } from 'lodash'

import { FormAutocomplete, FormAutocompleteProps } from '@collaborate-health/forms'
import {
  CertificateScopeType,
  CertificateTypeBaseResponse,
} from '@tabeeb/contracts/microservices/swagger-certificate-service'

export interface CertificateTypeFieldProps {
  name: string
  disabled?: boolean
  disableCloseOnSelect?: boolean
  types: CertificateTypeBaseResponse[]
  category?: number
  scope?: CertificateScopeType
  loading: boolean
  limitTags?: number
  multiple?: boolean
  onChange?: (event: React.SyntheticEvent, value: any) => void
}

const CertificateTypeField: React.FC<CertificateTypeFieldProps> = ({
  name,
  disabled = false,
  disableCloseOnSelect = false,
  types,
  category,
  scope,
  loading,
  multiple = false,
  limitTags = 1,
  onChange,
}) => {
  const options = useMemo<FormAutocompleteProps<number>['options']>(
    () =>
      orderBy(types, (t) => t.Name)
        .filter((type) => {
          return (!category || type.CategoryId === category) && (!scope || type.ScopeId === scope)
        })
        .map((option) => {
          const firstLetter = option.Name[0].toUpperCase()

          return {
            value: option.Id,
            name: option.Name,
            group: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
          }
        }),
    [category, scope, types]
  )

  return (
    <FormAutocomplete
      name={name}
      disabled={disabled}
      fullWidth
      limitTags={limitTags}
      label='Type'
      placeholder='Search type name...'
      loading={loading}
      disableCloseOnSelect={disableCloseOnSelect}
      options={options}
      groupBy={(option) => option.group!}
      multiple={multiple}
      onChange={onChange}
    />
  )
}

export default CertificateTypeField

